import { render, staticRenderFns } from "./BillingTransactionsTruckingTab.vue?vue&type=template&id=b77c595a&scoped=true"
import script from "./BillingTransactionsTruckingTab.vue?vue&type=script&lang=js"
export * from "./BillingTransactionsTruckingTab.vue?vue&type=script&lang=js"
import style0 from "./BillingTransactionsTruckingTab.vue?vue&type=style&index=0&id=b77c595a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c595a",
  null
  
)

export default component.exports